import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Wrapper, Label, Separator } from './Breadcrumb.styles'

const BreadcrumbItem = ({ path, label }) => (
  <Label>
    <Link to={path || ''}>{label}</Link>
  </Label>
)

const Breadcrumb = ({ generateLabels }) => {
  const location = useLocation()
  const { pathname } = location
  const pathnames = pathname.split('/').filter((x) => x)
  const labels = generateLabels
    ? generateLabels(pathnames)
    : pathnames.map((segment) => ({ title: segment, path: segment }))

  let currentPath = ''

  return (
    <Wrapper>
      {labels.map(({ title, path }, index) => {
        currentPath += `/${path}`

        return (
          <React.Fragment key={currentPath}>
            <BreadcrumbItem path={currentPath} label={title} />
            {index < labels.length - 1 && <Separator> / </Separator>}
          </React.Fragment>
        )
      })}
    </Wrapper>
  )
}

export default Breadcrumb
